import { get, readable, writable } from "svelte/store";
export class EventsService {
    constructor(url) {
        this.url = url;
        this.accessToken = null;
        this._isOpen = writable(false);
        this.handlersMap = new Map();
        this.isOpen = readable(false, set => this._isOpen.subscribe(set));
    }
    start(accessToken) {
        if (this.accessToken) {
            return;
        }
        this.accessToken = accessToken;
        this.connect();
    }
    end() {
        var _a;
        this.accessToken = null;
        (_a = this.ws) === null || _a === void 0 ? void 0 : _a.close();
    }
    subscribe(eventPattern, handler) {
        if (!this.handlersMap.has(eventPattern)) {
            this.handlersMap.set(eventPattern, this.createEventHandlers(eventPattern));
        }
        this.handlersMap.get(eventPattern).handlers.add(handler);
        this.send('subscribe', eventPattern);
        return () => this.unsubscribe(eventPattern, handler);
    }
    unsubscribe(eventPattern, handler) {
        if (!this.handlersMap.has(eventPattern)) {
            return;
        }
        const { handlers } = this.handlersMap.get(eventPattern);
        handlers.delete(handler);
        if (handlers.size === 0) {
            this.handlersMap.delete(eventPattern);
            this.send('unsubscribe', eventPattern);
        }
    }
    createPatternRegexp(eventPattern) {
        const willcarded = eventPattern
            .replace(/\*{2}/g, '[\\w\\.-]+')
            .replace(/\*/g, '[\\w-]+');
        return new RegExp(`^${willcarded}$`);
    }
    send(...args) {
        if (!get(this._isOpen)) {
            return;
        }
        this.ws.send(JSON.stringify(args));
    }
    connect() {
        if (!this.accessToken || this.ws) {
            return;
        }
        this.ws = new WebSocket(`${this.url}?access_token=${this.accessToken}`);
        this.ws.addEventListener('open', () => this.onOpen());
        this.ws.addEventListener('close', () => this.onClose());
        this.ws.addEventListener('message', event => this.onMessage(event));
    }
    onOpen() {
        console.log('[Connection] Connection is open');
        this._isOpen.set(true);
        this.subscribeToAllEvents();
    }
    onClose() {
        console.log('[Connection] Connection is close');
        this._isOpen.set(false);
        this.ws = null;
        this.reconnect();
    }
    onMessage(event) {
        try {
            console.log(event);
            const [eventName, eventData] = JSON.parse(event.data);
            const eventHandlers = this.getEventHandlers(eventName);
            if (!eventHandlers) {
                //No hay manejadores registrados para este evento
                return;
            }
            const appEvent = {
                name: eventName,
                data: eventData,
            };
            for (const handler of eventHandlers.handlers) {
                handler(appEvent);
            }
        }
        catch (error) {
            console.error(error);
        }
    }
    reconnect() {
        window.clearTimeout(this.reconnectTimeout);
        if (!this.accessToken) {
            return;
        }
        this.reconnectTimeout = window.setTimeout(() => this.connect(), 5000);
    }
    subscribeToAllEvents() {
        if (!get(this._isOpen)) {
            return;
        }
        for (const eventPattern of this.handlersMap.keys()) {
            this.send('subscribe', eventPattern);
        }
    }
    getEventHandlers(eventName) {
        for (const eventHandlers of this.handlersMap.values()) {
            if (eventHandlers.regexp.test(eventName)) {
                return eventHandlers;
            }
        }
        return null;
    }
    createEventHandlers(eventPattern) {
        return {
            regexp: this.createPatternRegexp(eventPattern),
            handlers: new Set(),
        };
    }
}
